import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=c46d59a6&scoped=true"
import script from "./goods.vue?vue&type=script&lang=ts"
export * from "./goods.vue?vue&type=script&lang=ts"
import style0 from "./goods.vue?vue&type=style&index=0&id=c46d59a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46d59a6",
  null
  
)

export default component.exports